// @flow
import type {SagaIterator} from 'redux-saga';
import {FULFILLED} from 'redux-promise-middleware';

import {CUSTOMER} from 'constants/actions';

import {analytics} from 'libs/analytics/analytics';
import {getCustomer} from 'selectors/customer/customer';
import {call, take, select} from 'redux-saga/effects';

/**
 * Save customer's email in dataLayer if customer is subscribed
 */
export function* mktgEmail(): SagaIterator {
    yield take(`${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`);

    const {sid, email, md5} = yield select(getCustomer);

    yield call(
        analytics,
        {
            mktg_email: sid ? email : '',
            mktg_hashed_email: sid ? md5 : '',
        },
        true,
    );
}
